import React, { useMemo } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { resolveGrowthAndReturnCards } from '../config/growthAndReturnSummary';

function GrowthAndReturnSummary({ profitAndLoss, growthAndReturn, onMetricInfo }) {
    const cards = useMemo(
        () => resolveGrowthAndReturnCards(profitAndLoss, growthAndReturn),
        [profitAndLoss, growthAndReturn],
    );

    return (
        <section className="cfs-growth-summary" aria-label="Growth and Return Summary">
            <h4 className="cfs-growth-summary-heading">Growth &amp; Return Summary</h4>
            <p className="cfs-growth-summary-note">
                Snapshot statistics as stored from Screener. These are not fiscal-year table columns.
            </p>
            <div className="fin-bench-cards cfs-growth-summary-grid">
                {cards.map((card) => (
                    <article key={card.id} className="fin-bench-card cfs-growth-card">
                        <div className="fin-bench-card-head">
                            <h5 className="fin-bench-card-title">{card.title}</h5>
                            <FontAwesomeIcon
                                icon="circle-info"
                                title="View AI-powered definition"
                                className="cfs-growth-card-info"
                                style={{ cursor: 'pointer' }}
                                onClick={() => onMetricInfo?.(card.title)}
                            />
                        </div>
                        <dl className="cfs-growth-card-lines">
                            {card.lines.map((line) => (
                                <div key={line.period} className="cfs-growth-card-line">
                                    <dt>{line.period}</dt>
                                    <dd className={line.available ? undefined : 'cfs-growth-card-missing'}>
                                        {line.display}
                                    </dd>
                                </div>
                            ))}
                        </dl>
                    </article>
                ))}
            </div>
        </section>
    );
}

export default GrowthAndReturnSummary;
